export default function(h) {
  return h(
    'i',
    {
      class: this.$_class,
      style: this.$_style,
      directives: this.$_directives,
      on: this.$eventHandlers
    }
  )
}
